import React from "react";
import {Grid} from "@mui/material";
import ResourceAccessProfile from "./ResourceAccessProfile";

const AccessProfile: React.FC = () => {


    return (<>
        <Grid container spacing={0.5}>
            <ResourceAccessProfile />
        </Grid>
    </>);
}

export default AccessProfile;
